<template>
  <div
    class="lv-risk-icon"
    :class="[color,{ zero: num=='0' }]"
    :style="{
      color: num=='0' ? null : color,
      'background-color': num=='0' ? null : backgroundColor
    }"
  >
    <i :class="leadingIcon" />
    <LvText h4 bold light-gray>{{ num }}</LvText>
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: ""
    },
    leadingIcon: {
      type: String,
      default: ""
    },
    num: {
      type: [String, Number],
      default: 0
    },
    backgroundColor: {
      type: String,
    }
  }
};
</script>